import { render, staticRenderFns } from "./CustomerGroupFilter.vue?vue&type=template&id=11c4d116&"
import script from "./CustomerGroupFilter.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports